module.exports = __webpack_public_path__ + "media/award-google-play-ea2e9b9f.png";